import { forwardRef } from 'react';

import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
  IconButtonPropsColorOverrides,
} from '@mui/material/IconButton';
import { OverridableStringUnion } from '@mui/types';

import { ButtonColorList } from '../theme/colorList';

declare module '@mui/material/IconButton' {
  export interface IconButtonPropsColorOverrides {
    internal: true;
  }
}

export interface IconButtonProps extends MuiIconButtonProps {
  color?: OverridableStringUnion<ButtonColorList, IconButtonPropsColorOverrides>;
  variant?: 'squared-text' | 'squared-contained' | 'squared' | 'circle';
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  return <MuiIconButton ref={ref} {...props} />;
});

IconButton.displayName = 'IconButton';

export default IconButton;
